<template>
	<v-dialog v-model="visible" fullscreen>
		<v-toolbar dark>
			<v-btn icon @click="back">
				<v-icon>fa-arrow-left</v-icon>
			</v-btn>
			<v-toolbar-title>Pair Device</v-toolbar-title>
		</v-toolbar>
		<wizard ref="wizard" :device="device" @close="close" />
	</v-dialog>
</template>

<script>
import Wizard from "@/api/wizards/Wizard";

export default {
	components: { Wizard },

	props: {
		device: { type: Object, default: null },
	},

	data: () => ({
		loading: false,
	}),

	computed: {
		// Automatically show this modal when we assign a non-null device.
		visible() {
			return !!this.device;
		},
	},

	methods: {
		back() {
			// tell wizard to stop
			this.$refs.wizard.close();
		},

		close() {
			this.$emit("close");

			// refresh devices
			this.$store.dispatch("devices/load");
		},
	},
};
</script>
